import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'; // Importación actualizada
import { PageEvent } from '@angular/material/paginator'; // Importación actualizada
import { DesitionBoxComponent } from 'src/app/modales/desition-box/desition-box.component';
import { EvaluacionesService } from 'src/app/services/evaluaciones.service';
import { ParametrosService } from 'src/app/services/parametros.service';
import { SessionServiceService } from 'src/app/services/session-service.service';

const ELEMENT_DATA: any[] = [];

@Component({
    selector: 'app-gestor-de-evaluaciones',
    templateUrl: './gestor-de-evaluaciones.component.html',
    styleUrls: ['./gestor-de-evaluaciones.component.scss'],
    standalone: false
})
export class GestorDeEvaluacionesComponent implements OnInit {
  length = 0;
  pageSize = 50;
  pageSizeOptions: number[] = [5, 20, 50, 100, 150];

  isLoading = false;
  displayedColumns: string[] = ['matricula', 'nombre', 'proceso', 'nivel', 'grado', 'resultadosea', 'resultadosep', 'sugerencia', 'decision', 'autorizar'];
  dataSource = ELEMENT_DATA;
  formulario = new FormGroup({
    nombre: new FormControl(""),
    nivel: new FormControl(""),
    grado: new FormControl("")
  });
  niveles = [];
  grupos = [];
  public id_perfil: any;

  constructor(
    private _parametrosService: ParametrosService,
    private _evaluacionesService: EvaluacionesService,
    public dialog: MatDialog, // Cambiado aquí
    public _session: SessionServiceService
  ) {
    this._parametrosService.findAll("niveles").subscribe(result => {
      console.log(result);
      this.niveles = result.datos.niveles;
    }, error => {
      console.error('Error al cargar niveles:', error);
    });
  }

  ngOnInit(): void {
    this.id_perfil = this.getSesion().id_perfil_fk;
    console.log(this.id_perfil);
    this.setDefaultNivel();
    this.buscador(0);
  }

  getSesion() {
    return this._session.getSession().getUsuario();
  }

  setDefaultNivel() {
    const perfilNiveles: { [key: number]: string } = {
      5: '0',
      11: '1',
      12: '3',
      6: '1',
      7: '2',
      8: '3',
      9: '4'
    };
    this.formulario.patchValue({ nivel: perfilNiveles[this.id_perfil] || '' });
  }

  pageEvent(event: PageEvent) {
    console.info(event);
    this.pageSize = event.pageSize;
    this.buscador(event.pageIndex);
  }

  buscador(indice: number) {
    this._evaluacionesService.find(
      this.formulario.controls["nombre"].value,
      this.formulario.controls["nivel"].value,
      this.formulario.controls["grado"].value,
      0,
      this.pageSize
    ).subscribe(result => {
      console.log(result);
      this.dataSource = result.datos.evaluaciones;
      this.length = result?.datos?.evaluaciones?.length || 0;
    });
  }

  save(evaluacion: any, ciclo: any, nivel: any, grado: any, alumno: any, desicion: any) {
    console.info(desicion);
  }

  print(info: any) {
    console.info(info);
  }

  actualizar(campo: string, valor: string, evaluacion: any, ciclo: any, nivel: any, grado: any, alumno: any) {
    console.info(valor);
    const json = {
      campo: campo,
      valor: valor,
      evaluacion: evaluacion,
      ciclo: ciclo,
      nivel: nivel,
      grado: grado,
      alumno: alumno
    };
    const spinnerId = `spin_${campo}_${evaluacion}_${ciclo}_${nivel}_${grado}_${alumno}`;
    document.getElementById(spinnerId).style.display = "block";

    this._evaluacionesService.update(json).subscribe(() => {
      document.getElementById(spinnerId).style.display = "none";
    });
  }

  autorizar(campo: string, valor: string, evaluacion: any, ciclo: any, nivel: any, grado: any, alumno: any): void {
    const dialogRef = this.dialog.open(DesitionBoxComponent, {
      data: { title: "Solicitud de confirmación", text: "¿Está seguro que desea autorizar este registro?", icon: "help_outline" }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed' + result);
      if (result) {
        this.isLoading = true;
        const json = {
          campo: campo,
          valor: valor,
          evaluacion: evaluacion,
          ciclo: ciclo,
          nivel: nivel,
          grado: grado,
          alumno: alumno
        };
        this._evaluacionesService.update(json).subscribe(() => {
          this.isLoading = false;
          this.buscador(0);
        });
      }
    });
  }
}
